// PulsanteAmicizia.tsx — v033: «Aggiungi agli amici» (a fine partita e sul profilo pubblico). Dopo il tocco:
// «Richiesta mandata» (l'altro la trova in Amici) o, se l'altro l'aveva già chiesta, «Siete amici!».
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ErroreRete } from "../servizi/api.ts";
import { vibra } from "../servizi/nativo.ts";
import { vai } from "../servizi/percorso.ts";
import type { StatoAmicizia } from "../servizi/amici.ts";
import { PERCORSO_AMICI } from "../costanti.ts";

export function PulsanteAmicizia({ stato: iniziale, chiedi, nome }: { stato: StatoAmicizia; chiedi: () => Promise<{ stato: "inviata" | "amici" }>; nome: string }) {
  const { t } = useTranslation();
  const [stato, setStato] = useState<StatoAmicizia>(iniziale);
  const [invio, setInvio] = useState(false);
  const [errore, setErrore] = useState<string | null>(null);
  useEffect(() => setStato(iniziale), [iniziale]);

  if (stato === "amici")
    return (
      <p className="ld-amicizia-fatta" role="status">
        <span aria-hidden="true">🤝</span> {t("amici.siete_amici", { nome })}
      </p>
    );
  if (stato === "inviata")
    return (
      <p className="nota-centrata ld-amicizia-inviata" role="status">
        {t("amici.richiesta_mandata", { nome })}
      </p>
    );
  return (
    <div className="ld-amicizia">
      {stato === "ricevuta" && <p className="nota-centrata">{t("amici.ti_ha_chiesto", { nome })}</p>}
      <button
        type="button"
        className="pulsante pulsante-secondario ld-pulsante-amicizia"
        disabled={invio}
        onClick={() => {
          setInvio(true);
          setErrore(null);
          chiedi()
            .then((r) => {
              vibra("successo");
              setStato(r.stato);
            })
            .catch((e: unknown) => setErrore(e instanceof ErroreRete ? e.codice : "generico"))
            .finally(() => setInvio(false));
        }}
      >
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
          <circle cx="9" cy="8" r="3.2" />
          <path d="M3 19c.6-3.3 3-5.2 6-5.2s5.4 1.9 6 5.2M18 8v6M15 11h6" />
        </svg>
        {stato === "ricevuta" ? t("amici.accetta") : t("amici.aggiungi")}
      </button>
      {errore && (
        <p className="admin-errore" role="alert">
          {errore === "troppi_amici" || errore === "troppe_richieste" ? t(`amici.errore_${errore}`) : t("account.errore_generico")}
        </p>
      )}
      {stato === "ricevuta" && (
        <button type="button" className="pulsante-link" onClick={() => vai(PERCORSO_AMICI)}>
          {t("amici.titolo")}
        </button>
      )}
    </div>
  );
}
